import PropTypes from 'prop-types';
import { useContext } from 'react';
import { SHOW_MORE } from '../../../config/text/text';
import ThemeContext from '../../../providers/ThemeProvider';
import Button from '../../_generic/button/PrimaryButton';

const AmenitiesButton = ({ onClick }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <Button
        className="outline primary-color full-width amenities-button"
        onClick={onClick}
      >
        {SHOW_MORE}
      </Button>
      <style jsx>
        {`
          :global(.primary-button.primary-color.amenities-button) {
            border-width: 1px;
            font-size: 10px;
            min-height: 22px;
            text-transform: none;
          }
          @media (min-width: ${theme.breakpoints.mdUp}) {
            :global(.primary-button.primary-color.amenities-button) {
              min-height: 18px;
            }
          }
          @media (min-width: ${theme.breakpoints.lgUp}) {
            :global(.primary-button.primary-color.amenities-button) {
              border-width: 1px;
              font-size: 14px;
              min-height: 30px;
            }
          }
        `}
      </style>
    </>
  );
};

AmenitiesButton.propTypes = {
  onClick: PropTypes.func,
};

export default AmenitiesButton;
